import { IonButton, IonPage, IonToast, useIonToast, useIonViewWillEnter } from '@ionic/react';
import { useEffect, useRef } from 'react';

import { ThunkDispatch } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { RootState } from '../App';
import { EmailCard } from '../components/EmailCard';
import { Input } from '../components/Forms/Input';
import { QuirkIonContent } from '../components/QuirkIonContent';
import { SiteLogoBanner } from '../components/SiteLogoBanner';
import { useLoading } from '../hooks/useQuirkLoading';
import { RegistrationState, resend, setEmail, setErrorMessage, setRegistered } from '../state/registrationSlice';

// styles
import styles from './ForgotPassword.module.css';
// eslint-disable-next-line css-modules/no-unused-class
import sharedStyles from '../styles/Shared.module.css';
// eslint-disable-next-line css-modules/no-unused-class
import onboardingStyles from '../styles/onboarding.module.css';
import isEmail from 'validator/lib/isEmail.js';

export const ResendRegistrationEmail: React.FC = () => {
	const state: RegistrationState = useSelector<RootState, RegistrationState>(state => state.registration);
	useLoading({
		isLoading: state.registered === 'registering',
		message: 'Please wait...'
	});
	const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
	const inputRef = useRef<any>(null);
	const [toast] = useIonToast();
	const history = useHistory();

	useIonViewWillEnter(() => {
		dispatch(setEmail(''));
		dispatch(setRegistered(null));
	});

	useEffect(() => {
		setTimeout(() => inputRef.current.setFocus(), 100);
	}, []);
	const registerAction = () => {
		const { email } = state;
		if (email && isEmail(email)) {
			dispatch(resend({ email }));
		} else {
			toast({ message: 'Please provide a valid email', duration: 2000, position: 'top', color: 'danger' });
		}
	};
	return (
		<IonPage>
			<QuirkIonContent flush>
				<div className="login-container">
					<SiteLogoBanner siteName={true} />
					<div className="space20" />
					{state.registered !== 'registered' && (
						<>
							<div className={sharedStyles.contentWrapper}>
								<div className={styles.formContainer}>
									<Input
										type="email"
										inputRef={inputRef}
										placeholder="Email"
										value={state.email}
										onChange={event => {
											dispatch(setEmail(event.target.value));
										}}
									/>

									<IonButton size="large" expand="block" onClick={registerAction}>
										Resend Registration Email
									</IonButton>

									<IonToast
										isOpen={state.errorMessage !== ''}
										duration={1500}
										message={state.errorMessage}
										color="danger"
										position="top"
										onDidDismiss={() => dispatch(setErrorMessage(''))}
									/>
								</div>
							</div>
						</>
					)}

					{state.registered === 'registered' && (
						<>
							<EmailCard
								header="Verification email was resent"
								message={`An email has been sent to ${state.email}. Please click the link in the email to verify your account`}
							/>
						</>
					)}
					<div className={onboardingStyles.panelRow}>
						<IonButton
							color="primary"
							fill="clear"
							size="default"
							className="radius8"
							onClick={() => history.push('/main/settings/login')}
							expand="block"
						>
							Go back to sign in
						</IonButton>
					</div>
				</div>
			</QuirkIonContent>
		</IonPage>
	);
};
